export class TimelineDataModel {
    constructor(
        public timelineHeading: string,
        public timelineContent: any,
        public timelineContentClass: string,
        public timelineIcon: string,
        public timelineIconClass: string
    ) { }
}